import VueGtag from 'vue-gtag';

// Vue Gtag Tracking
export const initGtag = async () => {
  try {
    const { default: getVm, getVueApp } = await import('@/main');
    const vm = getVm ? getVm() : null;

    if (
      vm?.$rsGlobals.$currentUser
        && !vm?.$rsGlobals.$currentUser.isSuperUser
        && !JSON.parse(window.localStorage.getItem('currentUserSettings') || '{}')?.impersonated
        && window.APP_CONFIG.VUE_APP_GTAG_ID
        && window.APP_CONFIG.VUE_APP_ENV === 'production'
    ) {
      // eslint-disable-next-line no-console
      console.log('gtag init');
      // vue-gtag@2 is a Vue 3 app plugin (app.use()) and auto-detects the installed
      // vue-router instance — no more third positional `router` argument.
      getVueApp().use(VueGtag, {
        config: {
          id: `${window.APP_CONFIG?.VUE_APP_GTAG_ID}`,
        }, // Google Site Tag ID
      });
    }
  } catch (err) {
    console.warn(err);
  }
};
